import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikHelpers, FormikValues } from "formik";
import { AxiosError } from "axios";
import { ReactComponent as ArrowLeft } from "../../assets/svg/arrow-left-grey.svg";
import axiosInstant from "../../api";
import { postForgotPassword } from "../../api/endpoints";
import {
  AuthCard,
  BasicPage,
  FieldText,
  Footer,
  FormButton,
  forgetPassSchema,
  ForgetPassFormInitialValues as initialValues,
} from "./components";

export function ForgetPasswordPage() {
  const navigate = useNavigate();

  const handleSubmit = async (
    values: FormikValues,
    { setSubmitting, setErrors }: FormikHelpers<typeof initialValues>
  ) => {
    setSubmitting(true);
    try {
      await axiosInstant.post(postForgotPassword(), values);
      navigate(`/forgot-password-submitted/${values.emailAddress}`);
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        const { data } = axiosError.response;
        const formError = typeof data === "string" ? data : data.error;
        const errorText =
          formError === "MissingParameters"
            ? "No Account Exists For This Email"
            : formError;
        setErrors({ form: errorText });
      }
    }
    setSubmitting(false);
  };

  return (
    <BasicPage>
      <AuthCard elevation={0} variant="outlined">
        <Box textAlign="center" display="flex" flexDirection="column" gap={5}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box position="relative">
              <Typography variant="h5">
                Forgot Password
              </Typography>
              <Box
                position="absolute"
                sx={{ top: 5, left: 12, cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                <ArrowLeft style={{ width: 18, height: 18 }} />
              </Box>
            </Box>
            <Typography
              variant="body1"
              color="#868686"
              className="px-6"
            >
              Enter the email to which your account is linked and we will send
              you an email to recover your password.
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={forgetPassSchema}
            validateOnChange={false}
            validateOnMount={false}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Stack spacing={5} width={1}>
                  <Stack spacing={2} marginBottom={5}>
                    <FieldText
                      name="emailAddress"
                      placeholder="Email"
                      fullWidth
                    />
                  </Stack>
                  <FormButton
                    text="Send recovery email"
                    isLoadingBtn
                    loading={isSubmitting}
                  />
                </Stack>
              </Form>
            )}
          </Formik>
        </Box>
      </AuthCard>
      <Footer />
    </BasicPage>
  );
}
